/**
 * AccountContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled account main container.
 */
const AccountContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  left: ${72 * Screen.widthRatio}px;
  top: ${100 * Screen.widthRatio}px;
  height: ${880 * Screen.widthRatio}px;
  width: ${1660 * Screen.widthRatio}px;
`;

export default withOpacity(AccountContainer);
